import React from 'react'
import { useContext } from 'react'
import { GlobalState } from '../../GlobalState'
import { useEffect } from 'react';
import moment from 'moment'
import { api } from '../../util/urlConfig';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function SupplierFeedbackNotifyComponent({ id }) {
    const [supFeedbackDetail, setSupFeedbackDetail] = useState(null);

    const getCusFeedbacks = async (supId) => {
        const res = await axios.get(`/supplierfeedback/${supId}`);
        setSupFeedbackDetail(res.data.response.data);
    }

    useEffect(() => {
        getCusFeedbacks(id)
    }, [id])

    return (
        <>
            {
                supFeedbackDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={supFeedbackDetail.supplier && supFeedbackDetail.supplier.upload_image ? api + "/" + supFeedbackDetail.supplier.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        supFeedbackDetail.supplier ? supFeedbackDetail.supplier.first_name + " " + supFeedbackDetail.supplier.last_name
                                            : supFeedbackDetail.created_by ? supFeedbackDetail.created_by.first_name + " " + supFeedbackDetail.created_by.last_name : ""
                                    }
                                </div>


                                <div className='notify-subname'>{supFeedbackDetail.note}</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(supFeedbackDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
